import Pinpoint from "./Pinpoint";

export default Pinpoint;